export const FETCH_DEPENDENTS_WITH_PARAMS =
  'dependents/FETCH_DEPENDENTS_WITH_PARAMS';
